import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getFromApi, postToApi, patchToApi, deleteFromApi} from "../api/auth";
import InlineRename from "../components/shared/InlineRename";
import ConfirmButton from "../components/shared/ConfirmButton";

export default function Storage() {
    const [folders, setFolders] = useState([]);
    const [name, setName]       = useState("");
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            const res = await getFromApi("api/storage");
            setFolders(res.data || []);
        } finally { setLoading(false); }
    };

    useEffect(() => { load(); }, []);

    const handleAdd = async (e) => {
        e.preventDefault();
        await postToApi("api/storage/folder", {name});
        setName(""); load();
    };

    const handleRename = async (id, newName) => {
        await patchToApi(`api/storage/folder/${id}`, {name: newName});
        load();
    };

    const handleDelete = async (id) => {
        await deleteFromApi(`api/storage/folder/${id}`);
        load();
    };

    return (
        <div>
            <div className="page-header">
                <h4><i className="bi bi-folder me-2" style={{color:"#8b5cf6"}}/>Storage</h4>
            </div>

            <div className="panel mb-4">
                <form onSubmit={handleAdd} className="row g-2 align-items-end">
                    <div className="col-md-9">
                        <label className="form-label small fw-medium">New folder</label>
                        <input className="form-control" placeholder="Folder name..." value={name} onChange={e => setName(e.target.value)} required/>
                    </div>
                    <div className="col-md-3">
                        <button type="submit" className="btn btn-dark w-100"><i className="bi bi-folder-plus me-1"/>Create</button>
                    </div>
                </form>
            </div>

            {loading ? <div className="text-muted text-center py-4">Loading...</div> : (
                <div className="row g-3">
                    {folders.map(f => (
                        <div key={f._id} className="col-sm-6 col-md-4 col-lg-3">
                            <div className="panel d-flex flex-column align-items-center text-center gap-2" style={{padding:"1.25rem"}}>
                                <i className="bi bi-folder-fill" style={{fontSize:"2.5rem",color:"#8b5cf6"}}/>
                                <div className="w-100">
                                    <InlineRename value={f.name} onSave={name => handleRename(f._id, name)} className="fw-medium"/>
                                    <div className="small text-muted">{f.subCount || 0} subfolder{f.subCount !== 1 ? "s" : ""}</div>
                                </div>
                                <div className="d-flex gap-2 w-100">
                                    <Link to={`/storage/${f._id}`} className="btn btn-sm btn-dark flex-grow-1">Open</Link>
                                    <ConfirmButton className="btn btn-sm btn-outline-danger" onConfirm={() => handleDelete(f._id)}>
                                        <i className="bi bi-trash"/>
                                    </ConfirmButton>
                                </div>
                            </div>
                        </div>
                    ))}
                    {!folders.length && (
                        <div className="empty-state">
                            <i className="bi bi-folder-plus"/>
                            <div>No folders yet.</div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
